export enum LOGIN_HELP {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=837373540
     */
    SIGN_IN_PAGE = 'LOGIN_HELP.SIGN_IN_PAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=838583169
     */
    LINK_TEXT_SHOWN_ON_SIGN_IN_SCREEN = 'LOGIN_HELP.LINK_TEXT_SHOWN_ON_SIGN_IN_SCREEN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=87740116
     */
    LOGIN_HELP_URL = 'ADMIN.MOBILE.LOGIN_HELP_URL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=838600373
     */
    SHOW_LINK_ON_SIGN_IN_SCREEN = 'LOGIN_HELP.SHOW_LINK_ON_SIGN_IN_SCREEN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=838612631
     */
    LAPTOP_SCREENSHOT_HELPER = 'LOGIN_HELP.LAPTOP_SCREENSHOT_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=838590441
     */
    DONT_KNOW_HOW_TO_SIGN_IN = 'LOGIN_HELP.DONT_KNOW_HOW_TO_SIGN_IN',
}
